import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEmail, requiredString } from '@/utils/zodUtils';
import { validatePhoneNumber } from '@/utils/zodValidation/validatePhoneNumber';

export const MerchantBrandingFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      brandName: requiredString(t),
      customerSupportEmail: requiredEmail(t).nullable(),
      customerSupportPhoneNumber: z.string().nullable(),
      homepageUrl: z.string().nullable(),
    })
    .strict()
    .refine((data) => validatePhoneNumber(data.customerSupportPhoneNumber), {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['customerSupportPhoneNumber'],
    });

export type MerchantBrandingFormType = z.infer<ReturnType<typeof MerchantBrandingFormSchema>>;
